export interface Client {
  Id?: Guid;
  Firstname?: string;
  Lastname?: string;
  Company?: string;
  QuestelEntityId?: Guid;
  CountryId?: number;
  State?: string;
  Address1?: string;
  Address2?: string;
  Email?: string;
  CustomerId?: number;
  City?: string;
  ZipCode?:string;
  CountryName?: string;
    ExpirationTime?: number;
    GeneralDeclarationId?: Guid;
    GeneralDeclarationFileName?: string;
}

export interface ClientData extends Client {}
export class ClientData implements Client {
  constructor(responseData: Client) {
    this.Id = responseData.Id;
    this.Firstname = responseData.Firstname;
    this.Lastname = responseData.Lastname;
    this.Company = responseData.Company;
    this.QuestelEntityId = responseData.QuestelEntityId;
    this.CountryId = responseData.CountryId;
    this.State = responseData.State;
    this.Address1 = responseData.Address1;
    this.Address2 = responseData.Address2;
    this.Email = responseData.Email;
    this.CustomerId = responseData.CustomerId;
    this.City = responseData.City;
    this.ZipCode = responseData.ZipCode;
      this.CountryName = responseData.CountryName;
      this.ExpirationTime = responseData.ExpirationTime;
      this.GeneralDeclarationId = responseData.GeneralDeclarationId;
      this.GeneralDeclarationFileName = responseData.GeneralDeclarationFileName;
  }

  public get Address() : string {
    var address = [];

    if(this.Address1) {
      address.push(this.Address1);
    }
    if(this.Address2) {
      address.push(this.Address2);
    }
    if(this.City) {
      address.push(this.City);
    }
    if(this.State) {
      address.push(this.State);
    }
    if(this.CountryName) {
      address.push(this.CountryName);
    }

    return address.join(", ");
  }
}
